import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const isTokenExpired = (token) => {
  if (!token) return true;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  } catch (error) {
    console.error("Invalid token:", error);
    return true; 
  }
}; 

export const Auth = ({ children, allowedRoles, ...rest }) => {
  const token = localStorage.getItem("token");

  if (!token || isTokenExpired(token)) {
    alert("Please login.");
    return <Navigate to="/" replace />;
  }

  if (allowedRoles && allowedRoles.length > 0) {
    let userRole;
    try {
      const decoded = jwtDecode(token);
      userRole = decoded.role;
    } catch (error) {
      console.error("Error decoding token for role check:", error);
      alert("Unauthorized access (Invalid token data).");
      return <Navigate to="/" replace />;
    }

    if (!allowedRoles.includes(userRole)) {
      alert("Access Denied. You do not have the required permissions.");
      return <Navigate to="/" replace />; 
    }
  }

  return children;
};